/**
 * Monta o `search` da DSL do backend (`GenericSpecificationBuilder`): critérios separados por `,`,
 * `'` no início do critério faz OU com o acumulado e `*` nas pontas do valor vira LIKE. Não há
 * escape, então o texto livre perde os caracteres reservados (e os curingas do LIKE).
 */
const RESERVADOS = /[,'*%\\]/g

export const sanitizaTextoBusca = (texto?: string | null) => {
  const limpo = (texto ?? '').replace(RESERVADOS, '').replace(/\s+/g, ' ').trim()
  return limpo === 'null' ? '' : limpo
}

/** OU entre os campos; vai no início da busca, porque o `'` agrupa com tudo o que veio antes. */
export const criterioTextoLivre = (campos: readonly string[], texto?: string | null) => {
  const valor = sanitizaTextoBusca(texto)
  if (!valor) return ''
  return campos.map((campo, i) => `${i ? "'" : ''}${campo}~*${valor}*`).join(',')
}

export const montaBusca = (...criterios: Array<string | false | null | undefined>) =>
  criterios.filter(Boolean).join(',')
